var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.56 8.227-3.34 3.34-1.783-1.784-1.1 1.1 2.884 2.883 4.438-4.439-1.1-1.1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.663 1.778C8.248 1.282 9.096 1 9.999 1c.903 0 1.752.282 2.337.778h.774c.86 0 1.556.696 1.556 1.555v.002h.778c.86 0 1.556.696 1.556 1.555v11.667c0 .86-.696 1.556-1.556 1.556H4.556c-.86 0-1.556-.697-1.556-1.556V4.89c0-.859.696-1.555 1.556-1.555h.777v-.002c0-.859.696-1.555 1.555-1.555h.775Zm5.447 3.889c.575 0 1.078-.312 1.347-.777h.987v11.667H4.556V4.89h.986c.269.465.771.777 1.346.777h6.222ZM8.335 3.335l.232-.268c.256-.294.804-.51 1.434-.51.63 0 1.178.216 1.434.51l.232.268h1.445v.778H6.89v-.778h1.445Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboard-check.3884fe12.svg";
export { ForwardRef as ReactComponent };